module.exports = __webpack_public_path__ + "img/组39.ebb5a461.png";